import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './WarrantyLogo.css';

const IS_MOBILE = __APP__ === 'mobile';
const LENGTH = IS_MOBILE ? 8 : 12;

class WarrantyLogo extends React.Component {
  static propTypes = {
    warranty: PropTypes.shape().isRequired,
    tooltipTitle: PropTypes.string,
    tooltipIcon: PropTypes.string,
  };

  static defaultProps = {
    tooltipTitle: '',
    tooltipIcon: '',
  };

  render() {
    const { warranty, tooltipTitle, tooltipIcon } = this.props;
    const lessFontSize = warranty.title.length > LENGTH ? { fontSize: 12 } : {};

    return (
      <React.Fragment>
        <img alt="" className={cx(s.tooltipIcon, tooltipIcon)} src={warranty.logo} />
        <span className={cx(s.tooltipTitle, tooltipTitle)} style={lessFontSize}>
          {warranty.title}
        </span>
      </React.Fragment>
    );
  }
}

export default withStyles(s)(WarrantyLogo);



// WEBPACK FOOTER //
// ./src/shared/components/WarrantyLogo/WarrantyLogo.js